import { useParams } from 'react-router';
import LogisticCenterListHead from '../components/LogisticCenterListHead';
import LogisticCenterProductTable from '../components/table/LogisticCenterProductTable';
import { useEffect, useState } from 'react';
import buskwarehousedetail from '../services/buskwarehousedetail';
import { stateKorea } from '../../utils/Languages';

const LogisticCenter = () => {
  const { id } = useParams<{ id: string }>();
  const [loading, setLoading] = useState(false);
  const [rowDataProducts, setRowDataProducts] = useState();
  const [totalProduct, setTotalProduct] = useState(0);
  const [selectedLogisticProduct, setSelectedLogisticProduct] = useState<
    React.Key[]
  >([]);
  const [pageSellerProduct, setPage] = useState(1);

  useEffect(() => {
    getLogisticProductList(id, pageSellerProduct);
  }, [pageSellerProduct]);

  const getLogisticProductList = async (id: string, page: number) => {
    setLoading(true);
    const buskProductList = await buskwarehousedetail.getLogisticProductList(
      id,
      page
    );
    const rowDataModified = buskProductList.data?.map(
      (r: any, index: number) => {
        return {
          ...r,
          key: r.id,
          // no: index + (page - 1) * 10 + 1,
          no: r.id,
          state: stateKorea(r.state)
        };
      }
    );
    setRowDataProducts(rowDataModified);
    setTotalProduct(buskProductList.count);
    setLoading(false);
  };

  const handleChangePage = (page: number) => {
    setPage(page);
  };

  return (
    <>
      <LogisticCenterListHead
        totalProduct={totalProduct}
        selectedLogisticProduct={selectedLogisticProduct}
      />
      <LogisticCenterProductTable
        loading={loading}
        rowDataProducts={rowDataProducts}
        totalProduct={totalProduct}
        getLogisticProductList={getLogisticProductList}
        selectedLogisticProduct={selectedLogisticProduct}
        setSelectedLogisticProduct={setSelectedLogisticProduct}
        handleChangePageSellerProduct={handleChangePage}
      />
    </>
  );
};

export default LogisticCenter;
